import React from "react";
import { CalculatorOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { Button, Popconfirm } from "antd";

import DownloadCsvLink from "./DownloadCsvLink";
import { useUserContext } from "./contexts/usercontext";
import { TYPES } from "./layouts/csv.assets";
import { ENTITY_TYPES } from "utils/constants";
import Services from "../services";
import Toaster from "../services/toaster";

const ChartResultsButtons = ({ entity, entityType = ENTITY_TYPES.CARD, selectedItems = [], clickDeleteItems }) => {
  const {
    user: { is_admin },
  } = useUserContext();

  const [label, href, resultsIdentifier] = {
    [ENTITY_TYPES.CARD]: ["card", `/managecards?filterType=id&filterValue=${entity.id}`, "card_results"],
    [ENTITY_TYPES.SEALED_WAX]: ["wax", `/manage-wax?filterType=id&filterValue=${entity.id}`, "sealed_wax_results"],
  }[entityType];

  const handleRecalculateStats = async () => {
    if (entity.id && entityType === ENTITY_TYPES.CARD) {
      const result = await Services.calculateStatsForCardLambda([entity.id]);
      if (result && result.error) {
        Toaster.ErrorNotification("Could not start the stats lambda!");
      }
      Toaster.SuccessNotification("Card Stats lambda successfully started!");
    } else if (entityType === ENTITY_TYPES.SEALED_WAX) {
      const result = await Services.calculateStatsForWaxLambda([entity.id]);
      if (result && result.error) {
        Toaster.ErrorNotification("Could not start the wax lambda!");
      }
      Toaster.SuccessNotification("Wax Stats lambda successfully started!");
    }
  };

  return (
    <div className="action-button-container" onClick={(e) => e.stopPropagation()}>
      {is_admin && Boolean(selectedItems.length) && (
        <Popconfirm
          title={`Permanently delete ${selectedItems.length} sales, are you sure?`}
          onConfirm={clickDeleteItems}
        >
          <Button size="small" type="danger" icon={<DeleteOutlined />} style={{ color: "#FFF", marginRight: 8 }}>
            Delete Result(s)
          </Button>
        </Popconfirm>
      )}
      {is_admin && (
        <>
          <Button
            type="primary"
            icon={<EditOutlined />}
            href={href}
            target="_blank"
            size="small"
            style={{ marginRight: 8 }}
          >
            Edit
          </Button>
          <Popconfirm
            title={`Are you sure you want to re-calculate all stats for this ${label}?`}
            onConfirm={handleRecalculateStats}
          >
            <Button type="primary" icon={<CalculatorOutlined />} href={href} size="small" target="_blank">
              Re-calc stats
            </Button>
          </Popconfirm>
        </>
      )}

      <DownloadCsvLink type={TYPES.AUCTION} data={entity[resultsIdentifier]} className="card-action-icon" />
    </div>
  );
};

export { ChartResultsButtons };
